import Auth from 'lib/AuthHelper';
import { history } from 'data/Store';

const AuthorizeRoute = (...allowedRoles) => {
  if (
    allowedRoles.length === 0 ||
    (allowedRoles.length === 1 && allowedRoles[0] === '*')
  )
    allowedRoles = '*';

  return ({ routes, params, location }, replace, next) => {
    if (!Auth.isLoggedIn())
      return history.replace({ pathname: '/login', state: { from: location } });
    if (!Auth.isInRole(allowedRoles)) return history.replace('/forbidden'); //the supplied replace() doesn't seem to be working
    next();
  };
};

export default AuthorizeRoute;
